(function () {
  function plain(html) {
    if (html === null || html === undefined) { return ''; }
    var d = document.createElement('div');
    d.innerHTML = String(html);
    return (d.textContent || '').trim();
  }

  function init(root) {
    if (!root || root.dataset.lfoptReady === 'true') { return; }
    var dataEl = root.querySelector('[data-lf-variants]');
    if (!dataEl) { return; }
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) { return; }
    root.dataset.lfoptReady = 'true';

    var strings = {};
    try { strings = JSON.parse(root.querySelector('[data-lf-strings]').textContent); } catch (e) { strings = {}; }

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-lfopt-btn]'));
    var idInput = root.querySelector('[data-lf-variant-id]');
    var priceEl = root.querySelector('[data-lf-price]');
    var compareEl = root.querySelector('[data-lf-compare]');
    var saveEl = root.querySelector('[data-lf-save]');
    var stockEl = root.querySelector('[data-lf-stock]');
    var skuEl = root.querySelector('[data-lf-sku]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addLabel = root.querySelector('[data-lf-add-label]');
    var optCount = variants[0].options.length;
    var firstRender = true;
    var fromLink = false;
    try { fromLink = !!new URL(window.location.href).searchParams.get('variant'); } catch (e) {}

    var selected = null;
    var startId = parseInt((idInput && idInput.value) || '0', 10);
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === startId) { selected = variants[i].options.slice(); break; }
    }
    if (!selected) { selected = variants[0].options.slice(); }

    function findExact(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < optCount; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) { return v; }
      }
      return null;
    }

    function anyAvailable(index, value) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.available || v.options[index] !== value) { continue; }
        var ok = true;
        for (var j = 0; j < optCount; j++) {
          if (j !== index && v.options[j] !== selected[j]) { ok = false; break; }
        }
        if (ok) { return true; }
      }
      return false;
    }

    function firstAvailableWith(index, value) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available && variants[i].options[index] === value) { return variants[i]; }
      }
      return null;
    }

    function showMedia(key) {
      if (!key) { return; }
      var gallery = document.querySelector('[data-product-gallery]');
      if (gallery && typeof gallery.lfGoToKey === 'function') {
        if (gallery.lfGoToKey(key)) { return; }
      }
      var slides = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-slide]'));
      var match = null;
      slides.forEach(function (s) { if (s.getAttribute('data-image-key') === key) { match = s; } });
      if (!match) { return; }
      slides.forEach(function (s) { s.classList.toggle('is-active', s === match); });
      var idx = match.getAttribute('data-index');
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-index') === idx); });
      var cur = document.querySelector('[data-gallery-current]');
      if (cur && idx !== null) { cur.textContent = String(parseInt(idx, 10) + 1); }
    }

    function render() {
      var variant = findExact(selected);

      buttons.forEach(function (btn) {
        var idx = parseInt(btn.dataset.optIndex, 10);
        var val = btn.dataset.optValue;
        var on = selected[idx] === val;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('is-unavailable', !anyAvailable(idx, val));
        if (on) {
          var out = root.querySelector('[data-lf-selected="' + idx + '"]');
          if (out) { out.textContent = val; }
        }
      });

      if (priceEl) { priceEl.textContent = variant ? plain(variant.price_f) : ''; }

      if (compareEl) {
        var hasCompare = !!(variant && variant.compare > variant.price);
        compareEl.textContent = hasCompare ? plain(variant.compare_f) : '';
        compareEl.classList.toggle('is-hidden', !hasCompare);
        if (saveEl) {
          saveEl.classList.toggle('is-hidden', !hasCompare);
          if (hasCompare && strings.save) {
            saveEl.textContent = plain(strings.save).replace('{{ amount }}', plain(variant.save_f));
          }
        }
      }

      if (skuEl) {
        var sku = variant && variant.sku ? variant.sku : '';
        var showSku = sku.length > 0 && sku.length < 24;
        skuEl.textContent = showSku ? sku : '';
        skuEl.classList.toggle('is-hidden', !showSku);
      }

      if (stockEl) {
        stockEl.classList.remove('is-low', 'is-out');
        if (!variant) {
          stockEl.classList.add('is-out');
          stockEl.textContent = strings.unavailable || '';
        } else if (!variant.available) {
          stockEl.classList.add('is-out');
          stockEl.textContent = strings.sold_out || '';
        } else if (variant.qty > 0 && variant.qty <= 5 && strings.low_stock) {
          stockEl.classList.add('is-low');
          stockEl.textContent = strings.low_stock.replace('{{ count }}', variant.qty);
        } else {
          stockEl.textContent = strings.in_stock || '';
        }
      }

      if (addBtn) {
        var buyable = !!(variant && variant.available);
        addBtn.disabled = !buyable;
        if (addLabel) {
          addLabel.textContent = buyable ? (strings.add_to_cart || '') : (variant ? (strings.sold_out || '') : (strings.unavailable || ''));
        }
      }

      if (variant) {
        if (idInput) { idInput.value = variant.id; }
        if (!firstRender || fromLink) { showMedia(variant.image_key); }
        if (!firstRender && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) {}
        }
      }
      firstRender = false;
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.optIndex, 10);
        var val = btn.dataset.optValue;
        if (selected[idx] === val) { return; }
        var next = selected.slice();
        next[idx] = val;
        var exact = findExact(next);
        if (!exact || !exact.available) {
          var alt = firstAvailableWith(idx, val);
          if (alt) { next = alt.options.slice(); }
        }
        selected = next;
        render();
      });
    });

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lf-buybox]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
